import React, { useMemo } from 'react';
import { Box, Stack } from '@mui/material';

import { MarketingContent, OfferActionHandler, OfferPresentationType } from '@ocx/data-offers';
import { offerMessages } from '@ocx/feat-offers';
import { ModalPaper } from '@ocx/ui-modals';
import { OfferDetails, OfferDetailsAction, OfferDetailsProps } from '@ocx/ui-offers';
import { EntriesTicket } from './components/EntriesTicket/EntriesTicket';

export interface IProductSweepsProps {
  memberEntries: number;
  offerId: string;
  marketingContent: MarketingContent;
  presentationType: OfferPresentationType;
  offerAction: OfferActionHandler | null;
  onClose(): void;
}
export const ProductSweeps: React.FC<IProductSweepsProps> = ({
  memberEntries,
  offerId,
  marketingContent,
  presentationType,
  offerAction,
  onClose,
}) => {
  const offerDetails: OfferDetailsProps = useMemo(() => {
    const loyaltyAction: OfferDetailsAction | null =
      offerAction && offerAction.title
        ? {
            onClick: () => {
              offerAction.handler(offerId);
              onClose();
            },
            title: offerMessages[offerAction.title as keyof typeof offerMessages],
          }
        : null;
    return {
      marketingContent,
      variant: presentationType === OfferPresentationType.Banner ? 'banner' : 'default',
      isLoading: false,
      isReturnable: false,
      loyaltyAction,
      onClose,
    };
  }, [marketingContent, offerAction, offerId, onClose, presentationType]);

  return (
    <Stack direction="column" minHeight="100%" overflow="auto">
      <Stack position="relative" minHeight={200} justifyContent="center" m="auto">
        <EntriesTicket entries={memberEntries} />
      </Stack>
      <Box zIndex={1}>
        <ModalPaper>
          <OfferDetails {...offerDetails} />
        </ModalPaper>
      </Box>
    </Stack>
  );
};
